module.exports = __webpack_public_path__ + "img/pizza-slice.7dcd9e0f.svg";